const handleInput = (e) => {
  let inputValue = '';

  switch (e.target.type) {
    case 'text':
      inputValue = e.target.value;
      break;

    case 'number':
      inputValue = e.target.value === '' ? '' : Number(e.target.value);
      break;

    case 'checkbox':
      inputValue = e.target.checked;
      break;

    default:
      break;
  }

  return inputValue;
};

export default handleInput;
